/* eslint no-param-reassign: "off" */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import SchoolType from '../../types/SchoolType';

interface State {
  ids: number[];
  values: Record<number, SchoolType>;
}

const initialState: State = {
  ids: [],
  values: {},
};

const schoolTypesSlice = createSlice({
  name: 'schoolTypes',
  initialState,
  reducers: {
    setAllSchoolTypes: (state, action: PayloadAction<SchoolType[]>) => {
      state.ids = [];
      state.values = {};

      action.payload.forEach((value) => {
        const { id } = value;
        state.ids.push(id);
        state.values[id] = value;
      });
    },
  },
});

export const selectSchoolTypes = (state: any): Record<number, SchoolType> => 
  state.schoolTypes.values;

export const { setAllSchoolTypes } = schoolTypesSlice.actions;
export default schoolTypesSlice.reducer;
